import { useEffect, useRef, useState } from 'react';

const CourseContent = () => {
  const titleRef = useRef(null);
  const cardsRef = useRef([]);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => [...prev, entry.target]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const modules = [
    {
      title: "Fundamentos da Eletricidade",
      topics: [
        "Conceitos básicos de eletricidade",
        "Segurança em instalações elétricas",
        "Ferramentas e equipamentos essenciais",
        "Normas técnicas (NBR 5410)"
      ]
    },
    {
      title: "Reparos e Manutenção",
      topics: [
        "Identificação de problemas comuns",
        "Troca de disjuntores",
        "Manutenção preventiva",
        "Solução de curto-circuitos"
      ]
    },
    {
      title: "Instalações Elétricas",
      topics: [
        "Dimensionamento de circuitos",
        "Iluminação",
        "Tomadas 127V e 220V",
        "Quadro Geral",
        "Chuveiros",
        "Sensor de Presença e foto elétrico",
        "Interfone",
        "Conectores Wago e derivação",
        "Painel automático caixa d'água",
        "Ventiladores",
        "Telefone fixo",
        "Antenas",
        "Lançamento de cabos",
        "Padrão Cemig",
        "Ferramentas manuais e elétricas",
        "E muito mais..."
      ]
    },

  ];

  return (
    <section id="curso" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2
          ref={titleRef}
          className={`text-4xl font-bold text-center text-gray-800 mb-12 ${visibleItems.includes(titleRef.current) ? 'animate-on-scroll' : 'opacity-0'}`}
        >
          Conteúdo do Curso
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {modules.map((module, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition-shadow border-t-4 border-[#E18E37] ${
                index === 2 ? 'md:col-span-2' : ''
              } ${visibleItems.includes(cardsRef.current[index]) ? 'animate-on-scroll' : 'opacity-0'}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center mb-4">
                <div className="bg-[#E18E37] text-gray-900 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">
                  {index + 1}
                </div>
                <h3 className="text-2xl font-bold text-gray-800">{module.title}</h3>
              </div>

              <ul className={`space-y-3 ${index === 2 ? 'md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-3 md:space-y-0' : ''}`}>
                {module.topics.map((topic, topicIndex) => (
                  <li key={topicIndex} className="flex items-start">
                    <svg className="w-6 h-6 text-[#E18E37] mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                    <span className="text-gray-700">{topic}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#pagamento"
            className="inline-block bg-[#E18E37] text-gray-900 px-10 py-4 rounded-lg text-lg font-semibold hover:bg-[#E18E37] transform hover:scale-105 transition-all duration-300 shadow-xl"
          >
            Quero me Inscrever
          </a>
        </div>
      </div>
    </section>
  );
};

export default CourseContent;
